/* global jQuery */

import { Module } from 'wrapper6'
import { debounce } from '../../utils/_debounce'

export default class CheckoutFragment extends Module {
  ready () {
    if (!jQuery('body').hasClass('woocommerce-checkout')) {
      return
    }

    this.eventListeners()
  }

  eventListeners = () => {
    jQuery('.woocommerce-billing-fields').on('input', 'input#billing_ean', debounce(this.eventListenerCallback.bind(this), 1000))
  }

  eventListenerCallback = (event) => {
    jQuery('body').trigger('update_checkout')
  }
}
